import { Toaster as Sonner, toast as sonnerToast } from "sonner";
import { useTheme } from "@/lib/theme";

/**
 * Branded sonner Toaster that follows the Noam ThemeProvider (dark/light).
 * Use the `notify` helpers below for consistent UX feedback across the app.
 */
export function NoamToaster() {
  const { theme } = useTheme();
  return (
    <Sonner
      theme={theme}
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        style: { fontSize: "13px" },
        className: "noam-toast",
      }}
    />
  );
}

// Stable API regardless of underlying lib changes
export const notify = {
  success: (msg, opts) => sonnerToast.success(msg, opts),
  error: (msg, opts) => sonnerToast.error(msg, opts),
  info: (msg, opts) => sonnerToast(msg, opts),
  warning: (msg, opts) => sonnerToast.warning(msg, opts),
};

// Format axios error payload → human-friendly string
export function fmtError(err, fallback = "Une erreur est survenue.") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  return fallback;
}
